import { invert } from "lodash";

class EnumObject {
  constructor(obj) {
    this.enum = obj;
    this.byLabels = this.getByLabels();
    this.byValues = this.getByValues();
  }
  getByLabels() {
    return this.enum;
  }
  getByValues() {
    return invert(this.enum);
  }
}

export const asEnum = obj => new EnumObject(obj);

export default EnumObject;
